module.exports = __webpack_public_path__ + "img/baseline-edit-24px.0d9eb0d0.svg";